import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, withHandlers } from 'recompose'
import { FormattedMessage } from 'react-intl'
import Swiper from 'react-id-swiper'

/*import LotsList from './LotList/index'
import Hero from './../components/Hero'
import NewsList from '../components/News/PreviewList'
import FundsList from '../components/Funds/PreviewList'*/
import Link from './../components/Link'
import { fetchingState } from '../helpers/hocs.js'

import { getTotalSum } from '../selectors/home.js'
import { getHomeData } from './../store/reducers/home'
import { get as getNews } from './../store/reducers/news'
import { getList as getPartners } from './../store/reducers/partners'
import { getFunds as getFundsSelector } from './../selectors/funds.js'
import { clearList, getFunds, getTotal as getTotalFunds } from './../store/reducers/funds/list.js'
import { getActions as getActionsSelector } from './../selectors/actions.js'//
import { clearList as clearListActions, getActions, getCount } from './../store/reducers/actions/list.js'
import { getExternalPartnersList } from "../selectors/externalpartners.js";
import { getTotal, getExternalPartners } from "../store/reducers/externalpartners/list.js";
import { getSum as getSumOfExternalPayments } from '../store/reducers/externalpayments'
import numeral from 'numeral'

const params = {
  //effect: 'coverflow',
  grabCursor: false,//true
  centeredSlides: true,
  slidesPerView: 'auto',
  loop: true,
  navigation: {
    hide: true
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  autoplay: true,
}
const params1 = {
  grabCursor: false,//true
  centeredSlides: true,
  slidesPerView: 'auto',
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
    hide: false
  },
  autoplay: {delay: 2000, disableOnInteraction: false},
}

const params2 = {
  grabCursor: false,//true
  centeredSlides: true,
  slidesPerView: 'auto',
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
    hide: false
  },
  autoplay: true,
}

const Home = ({ funds = [], news = [], total = 0, fundsTotal, actions = [], actionsCount, partners,//fetching
  items = [], totalExtPartners = 0, length = 0, fetching, loadMore, sum = 0, count = 0 }) => {//fetching ? null : 
  const index = 0, setIndex = 0;// = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };
  /*let cups = [{ _id: '0', image: '/assets/img/test/index/dublb.png', title: '',
    link: 'https://businessforcharity.today/actions/pomogayu_c_dablbi'},
    { _id: '1', image: '/assets/img/test/index/bionova.png', title: ''},
    { _id: '2', image: '/assets/img/test/index/netology.png', title: ''},
    { _id: '3', image: '/assets/img/test/index/bianca.png', title: ''}];*/

  let winwin = [{
    id: '0', image: '/assets/img/test/bullet.jpg',
    text: 'Возможность для клиентов реализовать свое желание помочь, не прикладывая для этого дополнительных усилий – фактически в один клик.'
  },
  {
    id: '1', image: '/assets/img/test/bullet.jpg',
    text: 'Укрепление положительного имиджа, стимулирование лояльности существующих клиентов и конкурентное преимущество для новых.'
  },
  {
    id: '2', image: '/assets/img/test/bullet.jpg',
    text: 'Дополнительный PR-повод и продвижение бренда партнерами в контексте благотворительной акции.'
  },
  {
    id: '3', image: '/assets/img/test/bullet.jpg',
    text: 'Укрепление лояльности со стороны сотрудников – всё чаще людям важно работать в социально-ответственных компаниях.'
  }]

  let logos = [{
    _id: '22', image: '/assets/img/test/index/buro.png', title: '',
    link: 'https://m.buro247.ru/lifestyle/obshcestvo/14-apr-2020-charity-in-crisis-olga-fler.html'
  },
  {
    _id: '23', image: '/assets/img/test/index/cosmo.png', title: '',
    link: 'https://www.cosmo.ru/stars/news/04-04-2020/meet-for-charity-i-kseniya-sobchak-proveli-blagotvoritelnyy-on-layn-aukcion/'
  },
  {
    _id: '24', image: '/assets/img/test/index/tatler.png', title: '',
    link: 'https://www.marieclaire.ru/stil-zjizny/olga-fler-v-teoriyu-shesti-rukopojatiy-ya-veryu-kak-nikto-drugoy-/'
  },
  {
    _id: '25', image: '/assets/img/test/index/marie_claire.png', title: '',
    link: 'https://www.marieclaire.ru/stil-zjizny/pravila-legkoy-blagotvoritelnosti-ili-kak-pomogat-kajdyiy-den/'
  },
  { _id: '26', image: '/assets/img/test/index/village.png', title: '' },
  {
    _id: '27', image: '/assets/img/test/index/marie_claire2.png', title: '',
    link: 'https://www.marieclaire.ru/stil-zjizny/olga-fler-v-teoriyu-shesti-rukopojatiy-ya-veryu-kak-nikto-drugoy-/'
  },];

  let quotes = [{ _id: '31', image: '/assets/img/test/quotes/quote1.png' }, 
  { _id: '32', image: '/assets/img/test/quotes/quote2.png' }, 
  { _id: '33', image: '/assets/img/test/quotes/quote3.png' }, 
  { _id: '34', image: '/assets/img/test/quotes/quote4.png' }];

  let infoPartners = [{ id: '41', image: '/assets/img/test/infoPartners/tatler.png', text: 'TatlerLogo' },
  { id: '42', image: '/assets/img/test/infoPartners/the_village.png', text: 'theVillageLogo' },
  { id: '43', image: '/assets/img/test/infoPartners/Harpers_Bazaar_logo.png', text: 'HarpersBazaarlogo' },
  { id: '44', image: '/assets/img/test/infoPartners/buro.png', text: 'Buro' },
  { id: '45', image: '/assets/img/test/infoPartners/marie_claire.png', text: 'MarieClaireLogo' },
  { id: '46', image: '/assets/img/test/infoPartners/cosmo.png', text: 'CosmoLogo' }]

  let partnersArr = [{ id: '51', image: '/assets/img/test/partners/bianca.png', text: 'BiancaLogo',
  link: '/externalpartners/bianca'  },
  { id: '52', image: '/assets/img/test/partners/bionova.png', text: 'BionovaLogo' ,
  link: '/externalpartners/5ec3a72b5192f43b558a17da'  },
  { id: '53', image: '/assets/img/test/partners/doublebi.png', text: 'Double-bLogo' ,
  link: '/externalpartners/dablbi'  },
  { id: '54', image: '/assets/img/test/partners/netologia.png', text: 'NetologiaLogo' ,
  link: '/externalpartners/netologiya'  },]

  let formats = [{ id: '61', image: '/assets/img/test/formats/banner1.png' },
  { id: '62', image: '/assets/img/test/formats/banner2.png' },
  { id: '63', image: '/assets/img/test/formats/banner3.png' },
  { id: '64', image: '/assets/img/test/formats/banner4.png' },
  { id: '65', image: '/assets/img/test/formats/banner5.png' },
  { id: '66', image: '/assets/img/test/formats/banner6.png' }]

  return (
    <div className='Home'>
      <div className='Container'>
        {/*<Swiper {...params}>
          {cups.map(el => (
            <div key={el._id}>
              <span className='Home__item-img-wrap'>
                <a href={el.link}>
                  <img className='Home__item-img' src={el.image} />
                </a>
                <h1 className='Home__item-top-center-title'>{el.title}</h1>
              </span>
            </div>
          ))}
        </Swiper>    DELETE LATER*/}
        {/*<div className="Home__row-big">
          Счетчик Добра
          {Бренды, которые уже меняют мир к <span className="Home__row-big-orange">лучшему</span> c Business For Charity/}
      </div>
        <div className='Home__row-medium_big'><span className='Home__row-medium_big-orange'>Business For Charity</span> – это сервис, который позволяет потребителям удобно участвовать в благотворительных проектах,
        покупая товары и заказывая услуги у своих любимых брендов.</div>
        <div className='Home__row-medium'>Благотворительный проект Business For Charity объединяет Бизнесы, Фонды и Людей,
          желающих внести вклад в социальное развитие общества, разрабатывая и внедряя технологичные, современные инструменты.</div>
        <div className="list">
          {items.map((el, i) => (//brandList
            (i < 6) && <div className='Home__list-row' key={el._id}>
              <a href={'/externalpartners/' + el._id} className='Home__list-col' >{el.title}</a>
              {(el.title !== 'Даблби' && el.title !== 'Нетология') &&
                <div className='Home__list-col-right'>{(numeral(el.sumOfExternalPayments).format('0,0') == 0) ?
                  'coming soon' : (numeral(el.sumOfExternalPayments).format('0,0') + ' ₽')}</div>
              }
              {(el.title === 'Даблби' || el.title === 'Нетология') &&
                <div className='Home__list-col-right Home__list-col-right-orange'>{(numeral(el.sumOfExternalPayments).format('0,0') == 0) ?
                  "started" : (numeral(el.sumOfExternalPayments).format('0,0') + ' ₽')}</div>
              }
            </div>
          ))}
        </div>
        <div className='Home__more'>
          <Link to="/externalpartners">
            <button className='Button Button_black'> {/*onClick={get.bind(this, { offset: items.length })} loading={fetching.button} /}
          Посмотреть всех партнеров
        </button>
          </Link>
        </div>
        <div className="Home__row-small">
          Сумма, собранная при содействии компаний-партнеров и направленная в
          благотворительные фонды и иные социально-ориентированные некоммерческие организации
      </div>
        {/*<div className="Home__row-extra-big">
          {(numeral(sum).format('0,0') == 0) ? 'coming soon' : (numeral(sum).format('0,0') + ' ₽')}
        </div>
        <div className="Home__row-medium">
          собрали на благотворительность
      </div>
        <div className="Home__row-extra-big">
          {(numeral(count).format('0,0') == 0) ? 'coming soon' : numeral(count).format('0,0')}
        </div>
        <div className="Home__row-medium">
          человек
            </div>*/}
        <div className='Home__row-medium_big'><span className='Home__row-medium_big-orange'>Business For Charity</span> – это сервис, который позволяет потребителям удобно участвовать в благотворительных проектах,
        покупая товары и заказывая услуги у своих любимых брендов.</div>

        <div className='Home__row-medium'>Проект помогает сделать любой бизнес социально ответственным,
            создавая простые и эффективные <span className='Home__row-medium-orange'>WIN-WIN решения,</span> которые помогут бизнесам стать настоящими
            <span className='Home__row-medium-orange'> Love Brands</span> для своих клиентов и обеспечат
            дополнительные потоки пожертвований благотворительным организациям.</div>

        <div className="Home__row-big Home__row-big-big_margin">
          Наши партнеры
        </div>
        <Swiper {...params1}>
          {partnersArr.map(el => (
            <dev className='Home__item-body' key={el.id}>
              <span className='Home__item-img-wrap'>
			    <a href={el.link}>
                  <img className='Home__item-img_partners' src={el.image} alt={el.text} />
				</a>
              </span>
            </dev>
          ))}
        </Swiper>

        <div className="Home__row-big Home__row-big-bottom">
          Почему это <span className="Home__row-big-orange">WIN-WIN</span>?
        </div>
        {
          winwin.map((action, i) => {
            return (
              <div className={(i == winwin.length - 1) ? 'HomeTable HomeTable-last' : 'HomeTable'} key={action.id} >
                <div className='HomeTable__inner' key={action.id}>
                  <img className='HomeTable__img' src={action.image} alt='bullet' />
                  <span className='HomeTable__text'>{action.text}</span>
                </div>
              </div>
            )
          }
          )
        }
        <div className='Home__item-row-center'>
          <Link to='/contacts'>
            <button className='Button Button_black'>
            Подключить свой бизнес
            </button>
          </Link>
        </div>

        <div className="Home__row-big Home__row-big-big_margin Home__row-big-bottom">
          Как это работает?
        </div>
        <div className='Home__row-medium Home__row-medium-list'>1.  Партнер оставляет заявку на подключение.</div>
        <div className='Home__row-medium Home__row-medium-list'>2.  Согласовываем механику и реализуем её под ключ.</div>
        <div className='Home__row-medium Home__row-medium-list'>3.  Партнер выбирает фонд(ы), которому хочет помогать.</div>
        <div className='Home__row-medium Home__row-medium-list'>4.  Теперь клиенты могут помочь в 1 клик, становясь ещё лояльнее к любимому бренду.</div>

        <div className="Home__row-big Home__row-big-big_margin">
          Форматы участия
        </div>
        <Swiper {...params2}>
          {formats.map(el => (
            <dev className='Home__item-body' key={el.id}>
              <span className='Home__item-img-wrap'>
                <img className='Home__item-img' src={el.image} />
              </span>
            </dev>
          ))}
        </Swiper>
        <div className='Home__item-row-center'>
          <Link to='/contacts'>
            <button className='Button Button_black'>
            Подключить свой бизнес
            </button>
          </Link>
        </div>

        <div className="Home__row-big">
          #КаждаяПокупкаИмеетЗначение
        </div>
        <Swiper {...params2}>
          {quotes.map(el => (
            <dev className='Home__item-body' key={el._id}>
              <span className='Home__item-img-wrap'>
                <img className='Home__item-img' src={el.image} />
              </span>
            </dev>
          ))}
        </Swiper>


        {/*<Swiper {...params}>
          {logos.map(el => (
            <dev key={el._id}>
              <span className='Home__item-img-wrap'>
                <a href={el.link}>
                  <img className='Home__item-img' src={el.image} />
                </a>
              </span>
            </dev>
          ))}
        </Swiper>
        <Swiper {...params2}>
          {quotes.map(el => (
            <dev className='Home__item-body' key={el._id}>
              <span className='Home__item-img-wrap'>
                <img className='Home__item-img' src={el.image} />
              </span>
            </dev>
          ))}
        </Swiper>
        <div className='Home__more'>
          <Link to="/funds">
            <button className='Button Button_black'> {/*onClick={get.bind(this, { offset: items.length })} loading={fetching.button} /}
          Посмотреть все фонды
        </button>
          </Link>
          </div>*/}

        <div className="Home__row-big">
          Информационные партнеры
        </div>
        <div className='Home__infoPartners' >
          {
            infoPartners.map((action, i) => {
              return (
                <img className='Home__infoPartners-item' src={action.image} alt={action.text} />
              )
            }
            )
          }
        </div>


      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  funds: getFundsSelector(state),
  ...getExternalPartnersList(state),
  currentLocale: state.intl.locale,
  sum: state.externalpayments.sum,
  count: state.externalpayments.count
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getExternalPartners, getSumOfExternalPayments//
}, dispatch)

export default compose(
  fetchingState(),//
  connect(mapStateToProps, mapDispatchToProps//, mergeProps
  ),
  lifecycle({
    async componentWillMount() {
      this.props.getExternalPartners(0, false)//
      this.props.getSumOfExternalPayments()
    }
  })
)(Home)



// WEBPACK FOOTER //
// ./src/containers/Home.jsx